import { Link } from "react-router-dom";
import { Reveal } from "../components/Reveal";
import { Typewriter } from "../components/Typewriter";
import { ThemeDark } from "../components/ThemeDark";
import { CountUp } from "../components/CountUp";
import { usePortfolio, BACKEND_URL } from "../hooks/usePortfolio";

const services = [
  { num: "01", title: "Brand Strategy", desc: "Positioning, naming, voice. The point of view everything else is built on." },
  { num: "02", title: "Visual Identity & Design", desc: "Logo systems, typography, color, art direction — across print and screen." },
  { num: "03", title: "UX / UI Design", desc: "Websites and digital products that carry the brand into every interaction." },
  { num: "04", title: "Brand Architecture", desc: "Portfolio structure, sub-brands, and guidelines that keep the system coherent." },
];

const stats = [
  { end: 100, suffix: "+", label: "Clients" },
  { end: 17, suffix: "+", label: "Years Experience" },
  { end: 300, suffix: "+", label: "Projects" },
];

const workPath = (slug) => `/work/${encodeURIComponent(slug)}`;

export default function Home() {
  const { data: clients = [] } = usePortfolio();
  const teaser = clients.slice(0, 12);

  return (
    <main>
      <section className="hero" data-testid="home-hero">
        <p className="eyebrow hero-fade" style={{ animationDelay: "0s" }}>
          Brand Identity & Design — Baqa al-Gharbiyye
        </p>
        <h1 className="hero-headline hero-typed" data-testid="home-headline">
          <Typewriter lines={["We build brands", "that don't blend in."]} speed={45} startDelay={400} />
        </h1>
        <p className="hero-sub hero-fade" style={{ animationDelay: "2.1s" }}>
          Cactus is a boutique studio for companies with a point of view.
        </p>
      </section>

      <section className="section home-stats" data-testid="home-stats">
        {stats.map((stat, i) => (
          <Reveal key={stat.label} delay={i * 80}>
            <div className="home-stat">
              <span className="home-stat-value">
                <CountUp end={stat.end} suffix={stat.suffix} pad={stat.pad} />
              </span>
              <span className="home-stat-label">{stat.label}</span>
            </div>
          </Reveal>
        ))}
      </section>

      <section className="section teaser" data-testid="home-teaser">
        <div className="teaser-head">
          <p className="eyebrow">Selected Clients</p>
          <Link to="/work" className="text-link" data-testid="see-all-work-link">
            See all work →
          </Link>
        </div>
        <div className="teaser-grid">
          {teaser.map((c, i) => (
            <Reveal key={c.slug} delay={i * 90} className={`teaser-item teaser-item--${c.slug}`}>
              <Link
                to={workPath(c.slug)}
                className="logo-card teaser-card"
                style={c.bg ? { background: c.bg } : undefined}
                data-testid={`teaser-card-${c.slug}`}
              >
                <img className="card-logo" src={`${BACKEND_URL}${c.logo}`} alt={c.name} loading="lazy" />
                <span className="card-descriptor">{c.industry || c.name}</span>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      <ThemeDark>
        <section className="section process" data-testid="home-process">
          <p className="eyebrow">What We Do</p>
          <div className="process-list">
            {services.map((s, i) => (
              <Reveal key={s.num} delay={i * 80}>
                <div className="process-row" data-testid={`process-row-${s.num}`}>
                  <span className="process-num">{s.num}</span>
                  <h3 className="process-title">{s.title}</h3>
                  <p className="process-desc">{s.desc}</p>
                  <span className="process-arrow">→</span>
                </div>
              </Reveal>
            ))}
          </div>
        </section>
      </ThemeDark>
    </main>
  );
}
